import React, { useState } from 'react';
import styles from "../css/Commentator.module.css";
import Box from "components/inputs/Box";
import Button from "components/inputs/Button";
import { Chip, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";

import {useDispatch, useSelector} from "react-redux";
import { commentatorActions } from "reducers/commentator";
import { commonActions } from "reducers/common";
import { resetArray } from "service/util/resetArray";
import CommentatorService from "service/apiConfig/CommentatorService";

const CommentatorSearch = ({ setPage }) => {
    const dispatch = useDispatch();
    const commentatorList = useSelector(state => state.commentatorData.commentatorList);
    const [keyword, setKeyword] = useState('');
    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value)
        if (e.target.value === "") {
            CommentatorService.getAll()
                .then(response => {
                    dispatch(commonActions.falseIsLoading());
                    const arr = resetArray(response)
                    dispatch(commentatorActions.setCommentatorList(arr));
                })
                .catch(err => console.log(err))
        }
    }
    const handleSearchKeyword = () => {
        if (keyword === "") {
            CommentatorService.getAll()
                .then(response => {
                    dispatch(commonActions.falseIsLoading());
                    const arr = resetArray(response)
                    dispatch(commentatorActions.setCommentatorList(arr));
                })
                .catch(err => console.log(err))
        } else {
            const filterData = commentatorList ? commentatorList.filter(comm =>  comm.name.includes(keyword) || comm.nameEng.toLowerCase().includes(keyword)) : [];
            dispatch(commentatorActions.setCommentatorList(filterData));
            setPage(1);
        }
    }
    const handleKeypressKeyword = (e) => {
        if (e.key === 'Enter' || e.key === 'Backspace') {
            handleSearchKeyword();
        }
    }
    return (
        <Box style={{ marginBottom: '1rem' }}>
            <div className={styles.searchKeywordWrap}>
                <Chip
                    label="키워드"
                    icon={<Search />}
                />
                <TextField onKeyDown={handleKeypressKeyword} className={styles.textInput} value={keyword} onChange={handleChangeKeyword} name={"keyword"} size={"small"} variant={"outlined"} />
                <Button onClick={handleSearchKeyword}>검색</Button>
            </div>
        </Box>
    );
};

export default CommentatorSearch;